import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            了解黑料在线的故事与使命
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
            {aboutContent.description}
          </p>

          <div className="grid grid-cols-3 gap-4 md:gap-8">
            {aboutContent.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-4xl font-heading font-black text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}